import Hero from "../sections/Hero";
import { WaterSavedCounter, WaterComparisonBars, TwoGlasses } from "../sections/EcoWater";
import BiggerProblems from "../sections/BiggerProblems";
import TrustMarquee from "../sections/TrustMarquee";
import WhyCarCare from "../sections/WhyCarCare";
import WhyCarza from "../sections/WhyCarza";
import Pricing from "../sections/Pricing";
import Comparison from "../sections/Comparison";
import HowItWorks from "../sections/HowItWorks";
import Services from "../sections/Services";
import ForBusiness from "../sections/ForBusiness";
import Partners from "../sections/Partners";
import LiveActivity from "../sections/LiveActivity";
import Testimonials from "../sections/Testimonials";
import InvestorTeaser from "../sections/InvestorTeaser";
import About from "../sections/About";
import FAQ from "../sections/FAQ";
import FinalCTA from "../sections/FinalCTA";

export default function HomePage() {
  return (
    <main className="pb-20 lg:pb-0">
      <Hero />
      <WaterSavedCounter />
      <BiggerProblems />
      <TrustMarquee />
      <WhyCarCare />
      <WhyCarza />
      <Pricing />
      <WaterComparisonBars />
      <TwoGlasses />
      <Comparison />
      <HowItWorks />
      <Services />
      <ForBusiness />
      <Partners />
      <LiveActivity />
      <Testimonials />
      <InvestorTeaser />
      <About />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
